/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const MoneroIconConfig = {
  name: 'MoneroIcon',
  height: 512,
  width: 496,
  svgPath: 'M352 384h108.4C417 455.9 338.1 504 248 504S79 455.9 35.6 384H144V256.2L248 361l104-105v128zM88 336V128l159.4 159.4L408 128v208h74.8c8.5-25.1 13.2-52 13.2-80C496 119 385 8 248 8S0 119 0 256c0 28 4.6 54.9 13.2 80H88z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(MoneroIconConfig);